import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import Markdown from 'components/Markdown'
import NewsletterForm from 'components/elements/NewsletterForm'

import { Wrapper, StyledText } from './styles'

export default function PostNewsletter({ lang }) {
   const { data } = useStaticQuery(query)
   const filteredData = data && data.nodes.find((el) => el.node_locale === lang)

   return filteredData ? (
      <Wrapper>
         {filteredData.subscriberText?.markdown && (
            <StyledText>
               <Markdown>{filteredData.subscriberText.markdown}</Markdown>
            </StyledText>
         )}
         <NewsletterForm placeholder={filteredData.ctaText} />
      </Wrapper>
   ) : null
}

const query = graphql`
   query newsletterBox {
      data: allContentfulComponentSubscriberBox(filter: { subscribeType: { eq: "newsletter" } }) {
         nodes {
            node_locale
            ctaText
            subscriberText {
               markdown: subscriberText
            }
         }
      }
   }
`
